import "./ShipmentGroupSidebarFn.scss";
import React, { useContext, useEffect, useState } from "react";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import { Socket } from "socket.io-client";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import IOrder from "../../../models/IOrder";
import INewAddress from "../../../models/INewAddress";
import * as _ from "lodash-es";
import IShipment_Group from "../../../models/IShipment_Group";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetAllSupplierTokensDTO from "../../../models/DTO/IOnGetAllSupplierTokensDTO";
import IOnGetOrdersDTO from "../../../models/DTO/IOnGetOrdersDTO";
import IGetOrdersDTO from "../../../models/DTO/IGetOrdersDTO";
import IOnGetOrdersTypeaheadDTO from "../../../models/DTO/IOnGetOrdersTypeaheadDTO";
import IGetOrdersTypeaheadDTO from "../../../models/DTO/IGetOrdersTypeaheadDTO";
import IOnCreateShipmentGroupDTO from "../../../models/DTO/IOnCreateShipmentGroupDTO";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import ICreateShipmentGroupDTO from "../../../models/DTO/ICreateShipmentGroupDTO";
import IUpdateShipmentGroupDTO from "../../../models/DTO/IUpdateShipmentGroupDTO";
import IOnUpdateShipmentGroupDTO from "../../../models/DTO/IOnUpdateShipmentGroupDTO";
import IGetOrderDTO from "../../../models/DTO/IGetOrderDTO";
import OrderSourceEnum from "../../../models/OrderSourceEnum";
import { ShipmentGroupCreateView } from "./ShipmentGroupCreateView/ShipmentGroupCreateView";
import { ShipmentGroupReviewView } from "./ShipmentGroupReviewView/ShipmentGroupReviewView";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IOnGetOrderDTO from "../../../models/DTO/IOnGetOrderDTO";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";

type Props = {
    shipmentGroup?: IShipment_GroupUI;
    cancel: (refreshData?: boolean, navToShipmentGroup?: boolean) => void;
};

export const ShipmentGroupSidebarFn = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const getDefaultCountry = (country: string) => {
        switch (country) {
            case "US":
            case "USA":
            case "United States":
            case "":
                return "USA";

            default:
                return country;
        }
    };

    /**
     * Check if the shipment group has an order associated to it, with a ship to.
     */
    const checkIfHasOrderShipTo = (): boolean => {
        let _hasOrderShipTo = false;

        if (!_.isNil(props.shipmentGroup) && !_.isNil(props.shipmentGroup.action) && props.shipmentGroup.action.type !== "new_shipment") {
            if (props.shipmentGroup.Orders && props.shipmentGroup.Orders.length === 1) {
                if (!_.isNil(props.shipmentGroup.Orders[0]?.ship_to_id)) {
                    // @ts-expect-error
                    _hasOrderShipTo = true;
                }
            }
        }

        return _hasOrderShipTo;
    };

    const getNewShipmentFromOrderEntryForOrder = (): { guid: string; name: string } | undefined => {
        let order: { guid: string; name: string } | undefined;

        if (props.shipmentGroup && props.shipmentGroup.action?.type === "new_shipment") {
            order = {
                guid: props.shipmentGroup.action.order_guid || "",
                name: props.shipmentGroup.action.order_name || "",
            };
        }

        return order;
    };

    const [selectedVendor, setSelectedVendor] = useState<IVendorModel | undefined>(_.get(props.shipmentGroup, "Vendor"));
    const [selectedOrders, setSelectedOrders] = useState<IOrder[]>(_.get(props.shipmentGroup, "Orders", []));
    const [vendorOrders, setVendorOrders] = useState<any[]>([]);
    const [note, setNote] = useState<string | undefined>(_.get(props.shipmentGroup, "note", ""));

    const [shipTo, setShipTo] = useState<INewAddress | undefined>();
    const [billTo, setBillTo] = useState<INewAddress | undefined>();
    const [billToSameAsShipTo, setBillToSameAsShipTo] = useState<boolean>(_.get(props.shipmentGroup, "bill_to_same_as_ship_to", true));
    const [countries, setCountries] = useState<any[]>([]);

    /**
     * This flag is utilized to show the Order Ship To address above the Ship To Block
     */
    const [hasOrderShipTo, setHasOrderShipTo] = useState<boolean>(checkIfHasOrderShipTo());

    const [originalShipmentStatusId, setOriginalShipmentStatusId] = useState<number | undefined>(
        _.get(props.shipmentGroup, "shipment_status_id")
    );
    const [isEditMode, setIsEditMode] = useState(true);

    const [isCarrierDisabled, setIsCarrierDisabled] = useState(false);
    const [isTrackingDisabled, setIsTrackingDisabled] = useState(false);
    const [currentView, setCurrentView] = useState<"create" | "review">("create");
    const [restrictedView, setRestrictedView] = useState<boolean>(false);
    const [isConnected, setIsConnected] = useState<boolean>(false);

    const [connectedVendors, setConnectedVendors] = useState<IVendorModel[]>([]);

    const [newShipmentFromOrderEntryForOrder, setNewShipmentFromOrderEntryForOrder] = useState<{ guid: string; name: string } | undefined>(
        getNewShipmentFromOrderEntryForOrder()
    );
    const [activeCreateUpdateShipment, setActiveCreateUpdateShipment] = useState<boolean>(false);
    const [isPerformingOrderLookup, setIsPerformingOrderLookup] = useState<boolean>(false);
    const [shipToCountry, setShipToCountry] = useState<string | undefined>(undefined);
    const [billToCountry, setBillToCountry] = useState<string | undefined>(undefined);

    const [isDropshipment, setIsDropshipment] = useState<boolean>(_.get(props.shipmentGroup, "is_dropshipment", false));
    const [isLocalPickup, setIsLocalPickup] = useState<boolean>(_.get(props.shipmentGroup, "is_local_pickup", false));
    const [isLocalDelivery, setIsLocalDelivery] = useState<boolean>(_.get(props.shipmentGroup, "is_local_delivery", false));

    const [hasShipstation, setHasShipstation] = useState<boolean>(!!supplierModel.Supplier_Integration.has_shipstation);
    const [createInShipstation, setCreateInShipstation] = useState<boolean>(
        !!supplierModel.Supplier_Integration.has_shipstation && !props.shipmentGroup?.shipstation_order_key
    );

    /**
     * Socket Functions Begin Here
     */
    const getOrder = (orderGuid: string) => {
        let vendorGuid: string | undefined = selectedVendor?.guid;

        if (_.isNil(vendorGuid) && props.shipmentGroup?.action?.vendor_guid) {
            vendorGuid = props.shipmentGroup.action.vendor_guid;
        }

        if (vendorGuid) {
            const data: IGetOrderDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                vendorGuid,
                supplierGuid: supplierModel.guid,
                orderGuid,
            };

            socket.emit(EndpointsEnum.OrderGetOrder, data);
        }
    };

    const onGetOrder = (data: IOnGetOrderDTO) => {
        setSelectedOrders([data.order]);
    };

    const getAllSupplierTokens = () => {};

    const onGetAllSupplierTokens = (data: IOnGetAllSupplierTokensDTO) => {
        setConnectedVendors(data.tokens.connectedVendors);
    };

    const setupShipmentData = (): ICreateShipmentGroupDTO | IUpdateShipmentGroupDTO | undefined => {
        if (selectedVendor) {
            const shipmentData: ICreateShipmentGroupDTO | IUpdateShipmentGroupDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                vendorGuid: selectedVendor.guid,
                supplierGuid: supplierModel.guid,
                is_dropshipment: isDropshipment,
                is_local_pickup: isLocalPickup,
                is_local_delivery: isLocalDelivery,
                // shipment_status_id: this.state.shipment_status_id,
                // shipping_carrier_id: this.state.shipping_carrier_id,
                note: note || "",
                ship_to: {
                    name: shipTo?.name,
                    company_name: shipTo?.company_name || "", // not setup yet
                    address_line_one: shipTo?.address_line_one,
                    address_line_two: shipTo?.address_line_two,
                    address_line_three: shipTo?.address_line_three,
                    city: shipTo?.city,
                    state: shipTo?.state,
                    postal_code: shipTo?.postal_code,
                    country: getDefaultCountry(shipTo?.country || ""),
                    phone: undefined, // not setup yet
                },
                bill_to_same_as_ship_to: billToSameAsShipTo,
                shipmentGroupGuid: _.get(props.shipmentGroup, "guid", undefined),
                order_ids: [],
            };

            if (!props.shipmentGroup?.shipstation_order_key && createInShipstation) {
                // @ts-expect-error
                shipmentData.create_in_shipstation = createInShipstation;
            }

            // @ts-expect-error
            if (!_.isNil(billTo) && !shipmentData.bill_to_same_as_ship_to) {
                shipmentData.bill_to = {
                    name: billTo.name,
                    company_name: undefined,
                    address_line_one: billTo.address_line_one,
                    address_line_two: billTo.address_line_two,
                    address_line_three: billTo.address_line_three,
                    city: billTo.city,
                    state: billTo.state,
                    postal_code: billTo.postal_code,
                    country: getDefaultCountry(billTo.country || ""),
                };
            } else {
                // @ts-expect-error
                if (shipmentData.bill_to_same_as_ship_to) {
                    shipmentData.bill_to = undefined;
                }
            }

            shipmentData.order_ids = selectedOrders.map((order: any) => {
                return order.guid;
            });

            if (isLocalPickup) {
                if (shipmentData.bill_to) {
                    shipmentData.bill_to.name = "";
                    shipmentData.bill_to.company_name = "";
                    shipmentData.bill_to.address_line_one = "";
                    shipmentData.bill_to.address_line_two = "";
                    shipmentData.bill_to.address_line_three = "";
                    shipmentData.bill_to.city = "";
                    shipmentData.bill_to.state = "";
                    shipmentData.bill_to.postal_code = "";
                    shipmentData.bill_to.country = "";
                }

                if (shipmentData.ship_to) {
                    shipmentData.ship_to.name = "";
                    shipmentData.ship_to.company_name = "";
                    shipmentData.ship_to.address_line_one = "";
                    shipmentData.ship_to.address_line_two = "";
                    shipmentData.ship_to.address_line_three = "";
                    shipmentData.ship_to.city = "";
                    shipmentData.ship_to.state = "";
                    shipmentData.ship_to.postal_code = "";
                    shipmentData.ship_to.country = "";
                }
            }

            return shipmentData;
        }
    };

    const createShipmentGroup = () => {
        const data = setupShipmentData();

        if (data) {
            socket.emit(EndpointsEnum.ShipmentCreateShipmentGroup, data);
            setActiveCreateUpdateShipment(true);
        }
    };

    const onCreateShipmentGroup = (data: IOnCreateShipmentGroupDTO) => {
        const notification: INotification = {
            title: "successfully_created_shipment_group",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        uiContext.notifyFn(null, notification);
        props.cancel(true);
    };

    const updateShipmentGroup = () => {
        const data = setupShipmentData();

        if (data) {
            socket.emit(EndpointsEnum.ShipmentUpdateShipmentGroup, data);
            setActiveCreateUpdateShipment(true);
        }
    };

    const onUpdateShipmentGroup = (data: IOnUpdateShipmentGroupDTO) => {
        const notification = {
            message: "SUCCESSFULLY UPDATED SHIPMENT",
            level: "success",
            position: "br",
        };

        uiContext.notifyFn(null, notification);
        props.cancel(true);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.TokenOnGetAllSupplierTokens, fn: onGetAllSupplierTokens },
        { endpoint: EndpointsEnum.ShipmentOnCreateShipmentGroup, fn: onCreateShipmentGroup },
        { endpoint: EndpointsEnum.ShipmentOnUpdateShipmentGroup, fn: onUpdateShipmentGroup },
        { endpoint: EndpointsEnum.OrderOnGetOrder, fn: onGetOrder },
    ];

    /**
     * Socket Functions End Here
     */

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        // getOrders();

        if (newShipmentFromOrderEntryForOrder) {
            getOrder(newShipmentFromOrderEntryForOrder.guid);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        if (selectedOrders && selectedOrders.length === 1) {
            if (!_.isNil(selectedOrders[0]?.ship_to_id)) {
                const _shipTo = selectedOrders[0]?.Ship_To || ({} as INewAddress);

                if (_shipTo && !_shipTo.name?.length && selectedOrders[0].Contact) {
                    _shipTo.name = selectedOrders[0]?.Contact.name;
                }

                let _createInShipstation = createInShipstation;

                const _isLocalPickup = selectedOrders[0]?.is_local_pickup || isLocalPickup;
                const _isLocalDelivery = selectedOrders[0]?.is_local_delivery || isLocalDelivery;
                const _isDropshipment = selectedOrders[0]?.is_dropship || isDropshipment;

                if (_isLocalDelivery || _isLocalPickup || _isDropshipment) {
                    _createInShipstation = false;
                }

                setIsLocalPickup(_isLocalPickup);
                setIsLocalDelivery(_isLocalDelivery);
                setIsDropshipment(_isDropshipment);
                setCreateInShipstation(_createInShipstation);
                setShipTo(_shipTo);

                isFormValid();

                // this.setState({
                //     has_order_ship_to: true,
                //     is_local_pickup,
                //     is_local_delivery,
                //     create_in_shipstation,
                //     ship_to: shipTo,
                // }, () => {
                //     this.isFormValid();
                // });
            }
        }
    }, [selectedOrders]);

    const getHeaderTitle = () => {
        let header = "create_shipment_group";

        if (!_.isNil(props.shipmentGroup)) {
            if (originalShipmentStatusId && originalShipmentStatusId >= 4) {
                header = "review_shipment_group";
            } else {
                header = "edit_shipment_group";
            }
        }

        return header;
    };

    const hasValidAddressBlock = (stateObj: any) => {
        let isValidAddressBlock = false;

        if (!_.isNil(stateObj)) {
            const fields = ["address_line_one", "city", "state", "postal_code", "country"];

            let missingField = false;

            for (const field of fields) {
                if (_.isNil(stateObj[field])) {
                    missingField = true;
                } else {
                    if (!stateObj[field].length) {
                        missingField = true;
                    }
                }
            }

            if (!missingField) {
                isValidAddressBlock = true;
            }
        }

        return isValidAddressBlock;
    };

    const isFormValid = () => {
        let hasSelectedVendor = false;
        let hasSelectedOrders = false;
        let hasShipToAddress = false;
        let hasBillToAddress = false;
        const hasBillToSameAsShipTo = billToSameAsShipTo;

        if (!_.isNil(selectedVendor)) {
            hasSelectedVendor = true;
        }

        if (!_.isNil(selectedOrders) && selectedOrders.length) {
            hasSelectedOrders = true;
        }

        hasShipToAddress = hasValidAddressBlock(shipTo);

        if (hasBillToSameAsShipTo) {
            hasBillToAddress = true;
        } else {
            hasBillToAddress = hasValidAddressBlock(billTo);
        }

        if (isLocalPickup) {
            hasShipToAddress = true;
            hasBillToAddress = true;
        }

        return hasSelectedVendor && hasSelectedOrders && hasShipToAddress && hasBillToAddress;
    };

    const removeOrderFromShipment = (order: IOrder, index: number) => {};

    return (
        <div className={"ShipmentGroupSidebarFn"}>
            {currentView === "create" ? (
                <ShipmentGroupCreateView
                    selectedOrders={selectedOrders}
                    shipmentGroup={props.shipmentGroup}
                    cancel={props.cancel}
                    headerTitle={getHeaderTitle()}
                    isFormValid={isFormValid}
                    createInShipstation={createInShipstation}
                    getDefaultCountry={getDefaultCountry}
                    changeView={(view: "create" | "review") => setCurrentView(view)}
                    isDropshipment={isDropshipment}
                    isLocalDelivery={isLocalDelivery}
                    isLocalPickup={isLocalPickup}
                    removeOrderFromShipment={removeOrderFromShipment}
                    restrictedView={restrictedView}
                    selectedVendor={selectedVendor}
                    setBillToFn={setBillTo}
                    setShipToFn={setShipTo}
                    setSelectedOrdersFn={setSelectedOrders}
                    setSelectedVendorFn={setSelectedVendor}
                    shipTo={shipTo}
                    billTo={billTo}
                    setIsLocalPickup={setIsLocalPickup}
                    setIsDropshipment={setIsDropshipment}
                    setIsLocalDelivery={setIsLocalDelivery}
                    setCreateInShipstation={setCreateInShipstation}
                    setBillToSameAsShipTo={setBillToSameAsShipTo}
                    billToSameAsShipTo={billToSameAsShipTo}
                />
            ) : null}
            {currentView === "review" ? (
                <ShipmentGroupReviewView
                    cancel={props.cancel}
                    selectedOrders={selectedOrders}
                    shipmentGroup={props.shipmentGroup}
                    headerTitle={getHeaderTitle()}
                    changeView={(view: "create" | "review") => setCurrentView(view)}
                    isDropshipment={isDropshipment}
                    isLocalDelivery={isLocalDelivery}
                    isLocalPickup={isLocalPickup}
                    createInShipstation={createInShipstation}
                    selectedVendor={selectedVendor}
                    shipTo={shipTo}
                    billTo={billTo}
                    updateShipmentGroup={updateShipmentGroup}
                    createShipmentGroup={createShipmentGroup}
                    activeCreateUpdateShipment={activeCreateUpdateShipment}
                    billToSameAsShipTo={billToSameAsShipTo}
                />
            ) : null}
        </div>
    );
};
